import styled from "styled-components"
import { Tr, Td } from "~styled/table"
import SkeletonWrapper from "~components/SkeletonWrapper"
import { PerkEligibility } from "~shapes/eligibility"
import { CompanyLogo } from "~components/companies/styled/company"
import { getFullImagePath } from "~utils/utils"
import colors from "~constants/colors"

interface EligibilityRowProps {
  eligibility: PerkEligibility
  isLoading: boolean
}

const EligibilityRow = ({ eligibility, isLoading }: EligibilityRowProps) => {
  return (
    <Tr key={eligibility.id}>
      <Td>
        <SkeletonWrapper isLoading={isLoading} circle height={32} width={32}>
          <Logo src={getFullImagePath(eligibility.logo)} />
        </SkeletonWrapper>
      </Td>
      <Td>
        <SkeletonWrapper isLoading={isLoading} width={160}>
          <PerkName>{eligibility.name}</PerkName>
        </SkeletonWrapper>
      </Td>
      <Td>
        <SkeletonWrapper isLoading={isLoading} width={60}>
          <CellText>{eligibility.company?.symbol || "—"}</CellText>
        </SkeletonWrapper>
      </Td>
      <Td>
        <SkeletonWrapper isLoading={isLoading} width={160}>
          <CellMono>{eligibility.eligibilityRules || "—"}</CellMono>
        </SkeletonWrapper>
      </Td>
      <Td>
        <SkeletonWrapper isLoading={isLoading} width={50}>
          <CellText>{eligibility.holdings ?? "—"}</CellText>
        </SkeletonWrapper>
      </Td>
      <Td>
        <SkeletonWrapper isLoading={isLoading} width={70}>
          <StatusChip $color={eligibility.eligible ? colors.green : colors.red}>
            {eligibility.eligible ? "Eligible" : "Not eligible"}
          </StatusChip>
        </SkeletonWrapper>
      </Td>
      <Td>
        <SkeletonWrapper isLoading={isLoading} width={60}>
          <CellText>{eligibility.redeemed ? "Yes" : "No"}</CellText>
        </SkeletonWrapper>
      </Td>
    </Tr>
  )
}

const Logo = styled(CompanyLogo)`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: cover;
`

const PerkName = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: ${colors.gray3};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 240px;
`

const CellText = styled.div`
  font-size: 13px;
  color: ${colors.gray6};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const CellMono = styled.div`
  font-size: 12px;
  font-family: monospace;
  color: ${colors.gray6};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
`

const StatusChip = styled.span<{ $color: string }>`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  color: ${colors.white};
  background: ${p => p.$color};
  white-space: nowrap;
`

export default EligibilityRow
